import type { Selector } from 'types';

export const getStateFilter: Selector<string> = (state) => state.ui.useCasePage.stateFilter;
export const getCustomerFilter: Selector<string> = (state) => state.ui.useCasePage.customerFilter;
export const getPlatformFilter: Selector<string> = (state) => state.ui.useCasePage.platformFilter;
export const getOutcomeFilter: Selector<string> = (state) => state.ui.useCasePage.outcomeFilter;

export const getExpandedCategories: Selector<string[]> = (state) =>
  state.ui.useCasePage.expandedCategories;

export const getSelectedCustomerOutcome: Selector<string> = (state) =>
  state.ui.useCasePage.selectedCustomerOutcome;
